// extracted by mini-css-extract-plugin
export default {"frameContainer":"ExamChallengeFrame_frameContainer__RzD91","questionsPicker":"ExamChallengeFrame_questionsPicker__ABR1Z"};